<template>
  <div id="notSatisfiedBoxCard">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
      v-show="showHeader"
    >
      <span style="font-size: 18px; font-weight: bold">意見調查滿意度（不滿意的旅客）</span>
      <router-link to="/agency/agencyOpinionSurvey/index">
        <el-button size="mini" icon="el-icon-arrow-right" circle text></el-button>
      </router-link>
    </div>
    <el-table
      size="mini"
      stripe
      :data="statisticsData"
      style="width: 100%"
      :max-height="dynamicMaxHeight"
    >
      <el-table-column prop="userName" label="">
        <template slot-scope="{ row }">
          <span style="color: #333">{{ row.userName }}</span
          ><br />
          <span style="color: #818181">{{ row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="satisfactionPoint" label="" width="80" align="right">
        <template slot-scope="{ row }">
          <div style="color: red; font-weight: 500; font-size: 16px">
            {{ row.satisfactionPoint }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="80">
        <template slot-scope="{ row }">
          <not-satisfied-detail-dialog :uid="row.userID" :travelID="row.travelID" :qid="row.qid" />
        </template>
      </el-table-column>
    </el-table>
    <el-card
      v-if="false"
      shadow="none"
      class="box-card-component"
      style="margin-top: 8px"
      :loading="listLoading"
    >
      <div
        style="margin-bottom: 4px"
        v-if="statisticsData && statisticsData.length > 0"
        :style="{ height: dynamicMaxHeight, overflowY: 'auto' }"
      >
        <div
          class="progress-item"
          v-for="(item, index) in statisticsData"
          :key="index"
          style="padding: 6px 0; display: flex; align-items: center; justify-content: space-between"
        >
          <div>
            <div
              style="
                display: flex;
                align-items: center;
                gap: 0 12px;
                line-height: 24px;
                letter-spacing: 0.1em;
              "
            >
              <strong>{{ item.userName }}</strong>
              <el-rate
                v-if="false"
                :value="item.satisfactionPoint"
                disabled
                show-score
                :colors="['#E16D6D', '#F7BA2A', '#F7BA2A']"
                text-color="#E16D6D"
                score-template="{value}"
              >
              </el-rate>
              <div style="display: flex; align-items: center; gap: 0 4px">
                <span style="color: #e16d6d; font-weight: 500">{{ item.satisfactionPoint }}</span>
                <svg-icon icon-class="star" style="color: #e16d6d; font-size: 10px" />
              </div>
            </div>
            <div style="font-size: 12px; line-height: 24px; letter-spacing: 0.1em">
              團號：{{ item.title }}
            </div>
          </div>
          <not-satisfied-detail-dialog
            :uid="item.userID"
            :travelID="item.travelID"
            :qid="item.qid"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import NotSatisfiedDetailDialog from './NotSatisfiedDetailDialog.vue'
import { getTravelsOpinionNoSatisfied } from '@/api/travel'

export default {
  props: {
    limit: {
      type: Number,
      default: 7,
    },
    dynamicMaxHeight: {
      type: [String, Number],
      default: '100%',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NotSatisfiedDetailDialog,
  },

  data() {
    return {
      listLoading: false,
      statisticsData: [],
    }
  },

  created() {
    this.getList()
  },
  methods: {
    getList() {
      const agencyCode = this.$store.getters.userInfo.agencyCode
      if (!agencyCode) return
      const params = {
        agencyCode: this.$store.getters.userInfo.agencyCode,
        limit: this.limit,
      }
      this.listLoading = true
      getTravelsOpinionNoSatisfied(params)
        .then(async res => {
          this.statisticsData = res.data
        })
        .catch(async err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
#notSatisfiedBoxCard {
  .box-card-component {
    .el-card__header {
      padding: 0px !important;
    }

    .el-card__body {
      padding: 0px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.box-card-component {
  .box-card-header {
    position: relative;
    height: 220px;

    img {
      width: 100%;
      height: 100%;
      transition: all 0.2s linear;

      &:hover {
        transform: scale(1.1, 1.1);
        filter: contrast(130%);
      }
    }
  }

  .progress-item {
    font-size: 14px;
  }

  .progress-item:not(:last-child) {
    border-bottom: 1px solid #ddd;
  }
}
</style>
